import { createFileRoute, redirect } from '@tanstack/react-router'
import { ProfilePage } from '../pages/ProfilePage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/profile')({
  component: Profile,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
      })
    }
  },
})

function Profile() {
  return <ProfilePage />
}
